import { Panel } from 'primereact/panel'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux';
import useEffectOnce from '../hooks/useEffectOnce';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { fetchData, sendmsgdata } from '../reduxactions/organizationactions/OrgDonorChatActions';
import { RootState } from '../reducers';
import { useSelector } from 'react-redux';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Toast } from 'primereact/toast';
import { Message } from 'primereact/message';
import { GFNButton } from '../ui';

const OrgDonorChat = () => {
    const uid = window.sessionStorage.getItem('uid');
    const usertype = window.sessionStorage.getItem('usertype');

    const dispatch = useDispatch()
    const [queryParams, setQueryParams] = useState(null);
    const location = useLocation();
    const data = useSelector((state: RootState) => state.orgchat.data);
    const chatdata = useSelector((state: RootState) => state.orgchat.chatdata);
    const toast = useRef(chatdata);


    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setQueryParams(params.get("donationID") as any);
    }, [location]);
    const { donationID } = useParams();

    // To get data
    const fetchDataAsync = async () => {
        try {
            await dispatch(fetchData(uid, usertype, donationID) as any);
            console.log("usertype", usertype);

        } catch (error) {
            console.error('Error fetching data', error)
        }

    }
    useEffectOnce(() => {
        fetchDataAsync();
    }, [dispatch])

    const [message, setMessage] = useState<string>('');
    const AddsMessage = async () => {
        try {
            await dispatch(sendmsgdata(uid, message, donationID) as any);
            setMessage('');
        } catch (error) {
            console.error('Error fetching data', error)
        }
        toast.current.show({ severity: 'success', summary: 'Messege Sent', detail: chatdata, life: 3000 })
        fetchDataAsync();
    }
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/org-donationcommunication.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };

    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        <section className="app-page-header">
                            <div>
                                <h1 className="app-page-title">Communication</h1>
                            </div>
                            <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                                Help for this Page
                                <i className="pi pi-question-circle"></i>
                            </a>
                        </section>
                        <Panel header="Direct Chat">
                            <div className="grid">
                                <div className="col-12">
                                    <div className="card direct-chat direct-chat-primary">
                                        {/* <Panel header="Direct Chat"> */}
                                            {data.map((response: any) =>

                                                <div className="grid">
                                                    <div className="col-2">
                                                        <p>{response.name}, {response.date} </p>
                                                    </div>
                                                    <div className="col-9">
                                                        <p>{response.msg} </p>
                                                    </div>
                                                </div>
                                            )}
                                            <div className="card-footer">
                                                <div className="grid">
                                                    <div className='col-10'>
                                                        <InputText value={message} data-testid="chat-input" placeholder="Type Message ..." className="w-full mb-10" onChange={(e) => setMessage(e.target.value)} />
                                                    </div>
                                                    <span className="input-group-btn">
                                                        <div className='col-2'>
                                                            {/* <Button severity="info" icon="pi pi-send" data-testid="chat-btn" rounded outlined onClick={AddsMessage} /> */}
                                                            <GFNButton buttonType="secondary" icon="pi pi-send" data-testid="chat-btn" rounded onClick={AddsMessage} />
                                                        </div>
                                                    </span>
                                                </div>
                                            </div>
                                        {/* </Panel> */}
                                    </div>
                                </div>
                            </div>
                        </Panel>
                    </div>
                </div>
            </div>
            <Toast ref={toast} >
                <Message severity="success" content={chatdata} />
            </Toast>

        </div>
    )
}
export default OrgDonorChat
